import {
  GET_PRACTICE_LIST,
  GET_PRACTICE_LIST_SUCCESS,
  GET_PRACTICE_LIST_FAILURE,
} from 'store/getPracticeList/getPracticesListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getPracticeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRACTICE_LIST:
      return { ...state, loading: true };
    case GET_PRACTICE_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PRACTICE_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getPracticeListReducer;
